import { Component, Input, OnInit } from '@angular/core';
import { Application } from '../../../modules/app-catalog/domain/models/application';
import { TenantContextService } from '../../tenant-context/tenant-context.service';
import { ApplicationHelper } from 'src/app/modules/app-catalog/domain/services/application-helper';
import { take } from 'rxjs';

export enum AppIconSize {
    SMALL = 'small',
    LARGE = 'large'
}

@Component({
    selector: 'cdp-app-icon',
    templateUrl: './app-icon.component.html',
    styleUrls: ['./app-icon.component.scss'],
    standalone: false
})
export class AppIconComponent implements OnInit {
    @Input() app: Application;
    @Input() size: AppIconSize = AppIconSize.LARGE;
    @Input() showDisabledState = true;
    themeColor = ApplicationHelper.defaultThemeColor;
    readonly AppIconSize = AppIconSize;

    constructor(private tenantContext: TenantContextService) {}

    ngOnInit(): void {
        this.tenantContext.tenantSelected$.pipe(take(1)).subscribe(tenant => {
            this.themeColor = tenant?.themeColor || ApplicationHelper.defaultThemeColor;
        });
    }
}
